module.exports = __webpack_public_path__ + "media/images/icons/inspired-a2d20dee3eb2ec4a662359dc20e7b6e3.png";